function codeOf(permission) {
  if (!permission) return null;
  if (typeof permission === 'string') return permission;
  return permission.code || permission.codigo || permission.clave || null;
}

export function resolvePermissionPreview({ roles = [], grants = [], denies = [] } = {}) {
  const inherited = new Set();
  roles.forEach((role) => {
    (role.permisos || role.permissions || []).forEach((permission) => {
      const code = codeOf(permission);
      if (code) inherited.add(code);
    });
  });

  const granted = new Set(grants.map(codeOf).filter(Boolean));
  const denied = new Set(denies.map(codeOf).filter(Boolean));
  denied.forEach((code) => inherited.delete(code));
  granted.forEach((code) => inherited.add(code));

  return {
    inherited: Array.from(inherited).sort(),
    granted: Array.from(granted).sort(),
    denied: Array.from(denied).sort(),
    effective: Array.from(inherited).sort(),
  };
}
